/*
 * Licensed to the Apache Software Foundation (ASF) under one or more
 * contributor license agreements.  See the NOTICE file distributed with
 * this work for additional information regarding copyright ownership.
 * The ASF licenses this file to You under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with
 * the License.  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import GraphEditor from './grapheditor';
export { default as GraphEditor, EventSource, NodeDragBehaviour } from './grapheditor';
export { Node, NodeMovementInformation } from './node';
export {
    Edge,
    DraggedEdge,
    EdgeDragHandle,
    Point,
    PathPositionRotationAndScale,
    TextComponent,
    edgeId,
    normalizePositionOnLine,
    setDefaultEdgeDragHandles,
} from './edge';
export { Marker } from './marker';
export { LinkHandle, calculateLinkHandleNormal, handlesForRectangle, handlesForCircle, handlesForPolygon, handlesForPath } from './link-handle';
export { ResizingManager, DefaultResizeStrategy, ResizeStrategy, ResizeOverlayOptions } from './resizing';
export { wrapText, wrapTextLines, wrapSingleLine } from './textwrap';


if (window.customElements.get('network-graph') == null) {
    window.customElements.define('network-graph', GraphEditor);
}
